import React from 'react'

type Props = {
    data    : {
        id          : string,
        icon        : string,
        color       : string,
        name        : string,
        description : string,
    }

    onClick : {(id:string):void}
}

export default function AddCustomFieldItem(props:Props) {
    const onClick = (e:any) => {
        e.stopPropagation()
        props.onClick(props.data.id)
    }

    return (
        <div className="item" onClick={onClick}>
            <div className={Classes("ui5-ico-custom-field s-50", props.data.icon, "bg-{0}".f(props.data.color))}/>
            <div className="info">
                <div className="name">{props.data.name}</div>
                <div className="description">{props.data.description}</div>
            </div>
        </div>
    )
}
